export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZakazkaPneu';

export const NAME = 'ZakazkaPneu';
